<template>
    <div class="data-intellige">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name:"data-intellige"
}
</script>

<style lang="less" scoped>

</style>
